import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactComponent } from './contact/contact.component';
import { ContactListComponent} from './contact-list/contact-list.component';
import { ContactTabComponent} from './contact-tab/contact-tab.component';

const routes: Routes = [
	{ path: '',  component: ContactComponent, children: [
		{ path: '', redirectTo: 'list', pathMatch: 'full' },
		{ path: 'list',  component: ContactListComponent },
		{ path: 'view/:id',  component: ContactTabComponent }		
	]},
	
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContactRoutingModule { }
